export default __webpack_public_path__ + "static/media/IBMPlexSans-SemiBold-Latin1.8af96d78.woff2";